document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fb-section').forEach(initFeedbacksSection);
});

// Support Shopify section re-renders in the theme editor
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.fb-section');
    if (section) initFeedbacksSection(section);
  });
}

function initFeedbacksSection(section) {
  if (section.dataset.fbInitialized) return;
  section.dataset.fbInitialized = 'true';

  var track = section.querySelector('.fb-track');
  var prevBtn = section.querySelector('.fb-arrow--prev');
  var nextBtn = section.querySelector('.fb-arrow--next');
  var dotsWrap = section.querySelector('[data-fb-dots]');
  var originalCards = Array.prototype.slice.call(section.querySelectorAll('.fb-card'));

  if (!track || originalCards.length === 0) return;

  // Give every original card a stable index used later to sync dots,
  // even after clones are appended for the infinite-scroll effect.
  originalCards.forEach(function (card, index) {
    card.setAttribute('data-fb-index', index);
  });

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var isMobile = window.matchMedia('(max-width: 749px)').matches;
var autoplayEnabled = section.dataset.fbAutoplay === 'true' && !prefersReducedMotion && !isMobile;
  var speed = parseFloat(section.dataset.fbSpeed) || 30; // pixels per second

  // --- Build dots (one per original card) ---
  originalCards.forEach(function (card, index) {
    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'fb-dot';
    dot.setAttribute('aria-label', 'Ir para depoimento ' + (index + 1));
    if (index === 0) dot.classList.add('is-active');
    dot.addEventListener('click', function () {
      pauseAutoplay();
      card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      resumeAutoplaySoon();
    });
    dotsWrap.appendChild(dot);
  });

  var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.fb-dot'));

  function setActiveDot(activeIndex) {
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === activeIndex);
    });
  }

  // --- Clone cards once, so the track can scroll endlessly without a visible jump ---
  var allCards = originalCards;
  var originalSetWidth = 0;

  if (autoplayEnabled) {
    originalCards.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      clone.querySelectorAll('a, button').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
      track.appendChild(clone);
    });

    allCards = Array.prototype.slice.call(track.querySelectorAll('.fb-card'));

    var measure = function () {
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0');
      var firstRect = originalCards[0].getBoundingClientRect();
      var lastRect = originalCards[originalCards.length - 1].getBoundingClientRect();
      originalSetWidth = (lastRect.right - firstRect.left) + gap;
    };

    measure();
    window.addEventListener('resize', measure);
  }

  function getCardWidthWithGap() {
    var style = getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap || '0');
    return originalCards[0].getBoundingClientRect().width + gap;
  }

  // --- Arrow navigation (also works while autoplay is on, with a brief pause) ---
  prevBtn.addEventListener('click', function () {
    pauseAutoplay();
    track.scrollBy({ left: -getCardWidthWithGap(), behavior: 'smooth' });
    resumeAutoplaySoon();
  });

  nextBtn.addEventListener('click', function () {
    pauseAutoplay();
    track.scrollBy({ left: getCardWidthWithGap(), behavior: 'smooth' });
    resumeAutoplaySoon();
  });

  // --- Keep dots in sync with whichever card sits at the left edge ---
  var scrollTimeout;
  track.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      var trackLeft = track.getBoundingClientRect().left;
      var closestCard = null;
      var closestDistance = Infinity;

      allCards.forEach(function (card) {
        var distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestCard = card;
        }
      });

      if (closestCard) {
        setActiveDot(parseInt(closestCard.getAttribute('data-fb-index'), 10));
      }
    }, 80);
  });

  // --- "Ver mais / ver menos" toggle ---
  section.querySelectorAll('[data-fb-toggle]').forEach(function (button) {
    var wrap = button.closest('.fb-text-wrap');
    var label = button.querySelector('[data-fb-more-label]');
    var moreLabel = label.textContent;
    var lessLabel = moreLabel.indexOf('+') !== -1
      ? moreLabel.replace('+', '–')
      : moreLabel;

    button.addEventListener('click', function () {
      var expanded = wrap.classList.toggle('is-expanded');
      label.textContent = expanded ? lessLabel : moreLabel;
    });
  });

  // --- Autoplay: smooth, continuous, right-to-left, pauses on interaction ---
  if (!autoplayEnabled) return;

  var isPaused = false;
  var lastTimestamp = null;
  var resumeTimeout = null;
  var rafId = null;

  function pauseAutoplay() {
    isPaused = true;
  }

  function resumeAutoplaySoon(delay) {
    clearTimeout(resumeTimeout);
    resumeTimeout = setTimeout(function () {
      isPaused = false;
      lastTimestamp = null;
    }, delay === undefined ? 2000 : delay);
  }

  function tick(timestamp) {
    if (lastTimestamp === null) lastTimestamp = timestamp;
    var deltaSeconds = (timestamp - lastTimestamp) / 1000;
    lastTimestamp = timestamp;

    if (!isPaused && originalSetWidth > 0) {
      track.scrollLeft += speed * deltaSeconds;
      if (track.scrollLeft >= originalSetWidth) {
        track.scrollLeft -= originalSetWidth;
      }
    }

    rafId = requestAnimationFrame(tick);
  }

  rafId = requestAnimationFrame(tick);

  // Pause while the pointer is over the section, or while focused via keyboard/tab
  section.addEventListener('mouseenter', pauseAutoplay);
  section.addEventListener('mouseleave', function () {
    resumeAutoplaySoon(0);
  });
  section.addEventListener('focusin', pauseAutoplay);
  section.addEventListener('focusout', function () {
    resumeAutoplaySoon(0);
  });

  // Pause during manual touch/drag scrolling
  track.addEventListener('pointerdown', pauseAutoplay);
  track.addEventListener('pointerup', function () {
    resumeAutoplaySoon();
  });
  track.addEventListener('touchstart', pauseAutoplay, { passive: true });
  track.addEventListener('touchend', function () {
    resumeAutoplaySoon();
  }, { passive: true });
}